import React, { Fragment, Suspense, useContext } from "react";
import { Route } from "react-router-dom";

import { IRoute } from "../../routes.path";
import SystemContext from "../../context/systemContext";
import Loader from "../../components/loaders/pageLoader";
export interface IPrivateProps extends IRoute {
  children: JSX.Element | null;
}

let PrivateRouteAuth: React.FC<IPrivateProps>;
PrivateRouteAuth = ({ children, ...rest }: any) => {
  const context = useContext(SystemContext);
  return (
    <Fragment key={rest.key}>
      <Suspense
        fallback={
          <div
            className="position-relative"
            style={{ height: "100%", width: "100%" }}
          >
            <Loader />
          </div>
        }
      >
        <Route {...rest} render={({ location }) => children} />
      </Suspense>
    </Fragment>
  );
};

export default PrivateRouteAuth;
